// Animation and polling durations, collapsed to zero under test.
//
// Feature specs were spending real seconds waiting on things that exist purely
// for feel: a 2s pause before the points notification fades, a 400ms scroll
// animation before focus lands, a 500ms delay before audio replays. Multiplied
// across a suite of :js specs that's minutes of wall clock.
//
// The flag comes from data-test-mode on <html>, set by the layout only in the
// test environment (see layouts/application.html.haml), so production behaviour
// is untouched. The same layout also zeroes CSS transition and animation
// durations, which covers Bootstrap's modal fades.
export const fastMode = document.documentElement.dataset.testMode === 'true'

// FadeOutNotification: how long the "+N words" notice sits before fading.
export const NOTIFICATION_DELAY = fastMode ? 0 : 2000

// Sentence: pause before replaying audio on completion.
export const AUDIO_REPLAY_DELAY = fastMode ? 0 : 500

// Sentence: how long the "+N words" count stays up after completing a sentence.
export const WORD_COUNT_DELAY = fastMode ? 0 : 1500

// Article: the scroll-into-view animation that focus waits on in Play All.
// Zeroing this also removes the race the play-all focus spec had to poll around.
export const SCROLL_DURATION = fastMode ? 0 : 400
